import React from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import { Row, Typography, Col } from "antd";
import { ErrorBoundary } from "react-error-boundary";

import { useAppSelector } from "app/hooks";
import ErrorFallback from "components/ErrorFallback";
import {
  useGetNIBSSStatusEnumQuery,
  useGetSortCodeTypeEnumQuery,
  useGetTransactionTypeEnumQuery,
} from "app/configApiSlice";

import { TableWrapper, ReprocessContainer } from "./styled";

const { Title } = Typography;

const DataGeneration: React.FC = () => {
  const sortCodeEnum = useGetSortCodeTypeEnumQuery();
  const NIBSSStatusEnum = useGetNIBSSStatusEnumQuery();
  const transactionTypeEnum = useGetTransactionTypeEnumQuery();
  const layout = useAppSelector((state) => state.reprocess.layout);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ReprocessContainer>
        <Helmet>
          <title>NEFT Settlement | Re-Inject</title>
          <meta name="description" content="Helmet application" />
        </Helmet>
        <Row>
          <Col className="heading" span={24}>
            <Title level={4}>{layout.title}</Title>
          </Col>
        </Row>

        <TableWrapper>
          <Outlet
            context={{
              sortCode: sortCodeEnum.data,
              NIBSSStatus: NIBSSStatusEnum.data,
              transactionType: transactionTypeEnum.data,
            }}
          />
        </TableWrapper>
      </ReprocessContainer>
    </ErrorBoundary>
  );
};

export default DataGeneration;
